import React from 'react';
import { useAtomValue } from 'jotai';
import { userBranchesAtom, selectedBranchAtom } from '../../../Atoms';
import PageWrapper from '../../../Components/Paper/PageWrapper';
import { DEFAULT_STATS_TABS } from '../../../Utils/constants/general';
import getDefaultColumns from '../../../Components/ContactListWrapper/utils/getDefaultColumns';

const LightPage = function LightPage(props) {
  const userBranches = useAtomValue(userBranchesAtom);
  const selectedBranch = useAtomValue(selectedBranchAtom) || {};

  return (
    <PageWrapper
      columns={getDefaultColumns(userBranches, selectedBranch)}
      statsTabs={DEFAULT_STATS_TABS}
      period={120}
      {...props}
    />
  );
};

export default LightPage;
